<template>
  <div class="home-container2">
    <div class="home-container">
      <el-image :src="src" class="item-header-image">
        <div slot="placeholder" class="image-slot"></div>
      </el-image>
      <div class="image-mask">&nbsp;</div>
      <ItemInfo v-bind:info="info"></ItemInfo>
      <br />
      <ItemProgress v-bind:progress="progress"></ItemProgress>
      <br>
      <ItemComment v-bind:comment="comment"></ItemComment>
      <br>
      <DownloadAppBanner v-bind:buyLink="buyLink"></DownloadAppBanner>
      <br>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ItemInfo from "../../components/ItemInfo";
import ItemProgress from "../../components/ItemProgress";
import ItemComment from "../../components/ItemComment";
import DownloadAppBanner from "../../components/DownloadAppBanner";

export default {
  components: {
    ItemInfo,
    ItemProgress,
    ItemComment,
    DownloadAppBanner
  },

  data() {
    return {
      src:
        "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
      info: [
        { title: "物品", value: " " },
        { title: " ", value: " " },
        { title: "品牌", value: " " },
        { title: "型号", value: " " },
        { title: "来源", value: " " },
        { title: "价格", value: " " }
      ],
      comment: "comment",
      progress: {

      },
      buyLink: 'https://www.baidu.com'
    };
  },
  async mounted() {
    const option = {
      url: 'https://myitems.moshouapp.com/1.1/functions/fetchItem',
      method: 'POST',
      data: {
        id: this.$route.params.id,
      },
      headers: {
        'X-LC-Id': 'QoccwmtjlSyNmgzni7escoy9-gzGzoHsz',
        'X-LC-Key': 'i3EcxCSjfFeljEjxgMdrkfXK',
        'Content-Type': 'application/json',
      }
    }    
    const result = await axios(option)
    this.src = result.data.result.image
    this.info = result.data.result.info
    this.buyLink = result.data.result.info[4].buyLink
    this.progress = result.data.result.progress
    this.comment = result.data.result.comment
  }
};
</script>

<style>
.image-mask {
  background: #f5f5f5;
  border-radius: 15px 15px 0 0;
  margin-top: -24px;
  z-index: 2;
  height: 24px;
  width: 375px;
}
.item-header-image {
  height: 350px;
  width: 375px;
}
.home-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.home-container2 {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
}
body {
  background-color: #f5f5f5;
}
</style>